import { useState } from "react";
import { SelectedSearch } from "components/search/SearchSelector";

export interface ImportWizardState {
  kind: "search";
  search: SelectedSearch | null;
}

export const emptySearchState: ImportWizardState = {
  kind: "search",
  search: null,
};

export const useImportWizardState = () => {
  const [state, setState] = useState(emptySearchState);
  return { state, setState };
};
